module.exports = __webpack_public_path__ + "img/supplements.975448bb.svg";